<template>
  <div id="welcome">
    <div style="background: #fff; overflow: hidden">
      <SearchQuery :isReports="reportPage" :currentPage="currentPage" :searchName="searchName" ref="search"
        class="search-content">
        <el-button type="primary" icon="el-icon-search" size="small" style="margin-left: 15px" @click="search">{{
          $t("message.button.search") }}
        </el-button>
        <el-checkbox style="margin-left: 15px;bottom: -8px;" v-model="checked">{{ $t("message.button.BOMshow")
        }}</el-checkbox>
      </SearchQuery>
      <div style="height: 6px; background: #ebebeb"></div>
    </div>
    <div class="search_cotent">
      <el-card>

        <div v-loading="loading">
          <vxe-grid v-bind="gridOptions" resizable ref="table" :print-config="{}" :toolbar-config="tableToolbar"
            :checkbox-config="{ checkStrictly: true, checkMethod: noCheck }">
            <template #tools>
              <el-button @click="exportBOM" size="small" icon="el-icon-download" style="margin-right: 15px"
                :disabled='!gridOptions.data.length'>
                <!-- {{ $t("message.button.export") }} -->
                {{ $t("message.button.exportAll") }}
              </el-button>
            </template>
          </vxe-grid>

          <!-- <el-pagination
            small
            class="pagination"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="pageSizes"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalRols"
          >
          </el-pagination> -->
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import NProgress from "nprogress"; // 引入nprogress插件
import "nprogress/nprogress.css";
import TitleTag from "@/components/titleTag";
import SearchQuery from "@/views/workBench/search/searchItem/search.vue";
import axios from "axios";
// import XEUtils from "xe-utils";
import XLSX from "xlsx";
import FileSaver from "file-saver";
export default {
  name: "BOMReports",
  data() {
    return {
      searchName: "",
      checked: false,
      loading: false,
      reportPage: true,

      pageSizes: [100, 200, 500, 1000],
      pageSize: 100,
      currentPage: 1,

      totalRols: "",
      search_data: "",
      get_data: [],
      selectGroup: [],
      select_value: "",

      tableToolbar: {
        print: true,
        export: true,
        zoom: true,

        // custom: true,
        buttons: [{ code: 'myInsert', name: '', type: 'text', },],
        slots: {
          tools: "tools",
        },
      },
      gridOptions: {
        border: true,
        resizable: true,
        showOverflow: true,
        // stripe: true,
        height: 660,
        align: "left",
        highlightHoverRow: true,
        treeConfig: { children: "children", expandAll: true },
        editConfig: { trigger: "dblclick", mode: "row" },
        columns: [],
        data: [],
      },
    };
  },
  components: {
    SearchQuery,
    TitleTag,
  },
  mounted() {
    this.$store.commit('setIncludesList', 'BOMReports');
  },
  methods: {
    noCheck({ row }) {
      // console.log(row);
      return true
    },
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },

    exportBOM() {
      NProgress.start();
      // 对数据预处理
      const column = this.$refs.table.getColumns();
      const columnTitle = column.map((i) => i.title);
      columnTitle.shift()
      let data = [];
      data.push(columnTitle);
      // console.log(columnTitle,columnId);
      let dataList = this.getAllRow(this.gridOptions.data);
      // console.log(dataList);
      dataList.map(i => {
        // if (Array.isArray(i)) {
        //   data.push([])
        // }
        // else{
        //   delete i.children;
        //   delete i.objId;
        //   delete i._XID;
        //   let arr = Object.values(i)
        //   // console.log(arr);
        //   data.push(arr)
        // }
        delete i.children;
        delete i.objId;
        delete i._XID;
        delete i.objSubClassId
        let arr = Object.values(i);
        arr.pop()
        // console.log(arr);
        data.push(arr)
      })
      console.log(data);

      // // 转换数据
      let book = XLSX.utils.book_new();
      let sheet = XLSX.utils.json_to_sheet(data, { skipHeader: true });
      XLSX.utils.book_append_sheet(book, sheet);
      let wbout = XLSX.write(book, {
        bookType: "xlsx",
        bookSST: false,
        type: "binary",
      });
      let blob = new Blob([this.toBuffer(wbout)], {
        type: "application/octet-stream",
      });
      // 保存导出
      FileSaver.saveAs(blob, "BOM导出.xlsx");
      NProgress.done();
    },
    search(item) {

      const obj = this.$refs.search.getSearchInfo();
      this.$refs.search.searchShow = false;
      if (this.checked) {
        obj.currentPage = 0;
      }
      this.loading = true;
      this.gridOptions.columns = [];
      this.gridOptions.data = [];
      this.tableToolbar.buttons[0].name = ''
      axios
        .post("/search/advanced/searchBomAndExportExcel", obj)
        .then((res) => {
          this.getTable(res);
          this.loading = false;
        });
    },
    getTable(res) {
      // console.log("loadresult");
      const data = res.data.object.tableBOM;
      // console.log(data);
      if (data && data.totalRecords) {
        const arr = data.columnInfo;
        // console.log(data);
        let columnlist = [];

        arr.ids.map((i, e) => {
          columnlist.push({ title: arr.names[e], field: i, minWidth: "140", sortable: true });
        });
        columnlist[3].treeNode = true;

        this.gridOptions.columns = columnlist;
        this.totalRols = data.rows.length;
        let dataList = [];
        let tempList = this.getAllRows(data.rows);
        tempList = this.arrTrans(tempList);  //将tempList中相同的objId项分组 ==>二维数组
        tempList.map(i => {  //tempList 各项添加序号
          this.getBOMSeq(i)
        });
        tempList = tempList.reduce((a, b) => a.concat(b)); //将二维数组拍平
        tempList.map((i, e) => {
          if (e && i.objId == tempList[e - 1].objId) {
            i[1] = ''; i[2] = '';
            dataList.push(i)
          } else {
            // dataList.push([]);
            dataList.push(i)
          }
        })
        // dataList.shift();
        // this.getBOMSeq(dataList)
        console.log(dataList);
        this.gridOptions.data = dataList;
        let len = this.getAllRow(this.gridOptions.data).filter(i => !!i.objId);
        this.gridOptions.columns.unshift(
          { type: 'checkbox', width: 40 },
        );
        // console.log(len);
        this.tableToolbar.buttons[0].name = this.$t("message.title.totalResults") + len.length + this.$t("message.title.resultsNums")
      } else {
        this.tableToolbar.buttons[0].name = this.$t("message.title.totalResults") + 0 + this.$t("message.title.resultsNums")
      }

      // console.log("loadresult ending");
    },
    arrTrans(data) {
      let list = [];
      let arr = data.map(i => i.objId);
      arr = [...new Set(arr)];
      arr.map(i => {
        let n = data.filter(j => j.objId == i);
        list.push(n)
      })
      return list
    },
    getBOMSeq(array, l, n,) {

      if (!array || !array.length) return;
      let level = l || 1;
      let parentLevel = n || 0;
      array.forEach((item, e) => {
        item[3] = !parentLevel ? (e + 1) + "" : parentLevel + '.' + (e + 1 + '');
        if (level > 1) {
          item[1] = ''; item[2] = '';
          // item[3] = '1'
        }
        if (item.children && item.children.length) {
          this.getBOMSeq(item.children, level + 1, item[3]);
        }
        // console.log(item[1],e);

      })
      return array;
    },

    getAllRows(arr,) {
      // console.log(arr);
      let newArr = [];
      // let L = isLeaf || false;
      arr.map((i, e) => {
        let n = this.getRow(i);
        // console.log(n);
        newArr.push(n);
        if (i.children != null) {
          n.children = this.getAllRows(i.children,);
        } else {
          n.children = [];
        }
      });
      return newArr;
    },
    getRow(arr) {
      let n = {};
      // console.log(this.gridOptions.columns);
      n.objId = arr.objId;
      n.objSubClassId = arr.objSubClass;


      this.gridOptions.columns.map((i, e) => {
        let val = arr.cells[e].val || '';
        Object.assign(n, { [i.field]: val });
      });
      //console.log(n);
      return n;
    },

  },
  created() {
    // this.$nextTick( () =>
    //   this.$refs.table.setAllTreeExpansion(true)
    // )
  }
};
</script>


<style scoped>
.pagination {
  margin-top: 15px;
  text-align: left;
}

.search-condition {
  border-left: 8px solid #3ea0fb;
  padding-left: 12px;
  margin-left: 10px;
}

.search-title {
  /* width: 120px; */
  padding-right: 120px;
  margin-left: 15px;
}

.search-content {
  margin: 10px 10px;
}

.btn {
  display: inline-block;
  padding: 3px;
  padding-right: 10px;
  border: 1px solid #000;
  border-radius: 3px;
  cursor: pointer;
  margin-left: 8px;
  font-size: 14px;
}

.btn i {
  display: inline-block;
  width: 18px;
  height: 18px;
  position: relative;
  top: 3px;
  font-size: 14px;
}

.btn img {
  height: 100%;
  width: 100%;
}

.btn6 {
  height: 32px;
  /* line-height: 32px; */
  color: #f5a521;
  border-color: rgba(245, 165, 33, 0.5);
  background: rgba(245, 165, 33, 0.2);
  margin: 0;
  position: relative;
  /* top: 2px; */
}

.btn6:hover {
  color: #fff;
  background: rgba(245, 165, 33, 0.4);
}

.el-selector-search {
  width: 18px;
}
</style>